import { giornoRoma, formatGiornoEsteso, formatOraRoma } from '../utils/dateRoma';

export interface SlotBase { inizio: string; fine: string }
export interface GiornoSlot<T extends SlotBase> { giorno: string; etichetta: string; slot: (T & { ora: string })[] }

export function raggruppaSlotPerGiorno<T extends SlotBase>(slot: T[]): GiornoSlot<T>[] {
  const mappa = new Map<string, GiornoSlot<T>>();
  const ordinati = [...slot].sort((a, b) => a.inizio.localeCompare(b.inizio));
  for (const s of ordinati) {
    const giorno = giornoRoma(s.inizio);
    if (!mappa.has(giorno)) mappa.set(giorno, { giorno, etichetta: formatGiornoEsteso(s.inizio), slot: [] });
    mappa.get(giorno)!.slot.push({ ...s, ora: formatOraRoma(s.inizio) });
  }
  return Array.from(mappa.values()).sort((a, b) => a.giorno.localeCompare(b.giorno));
}
